
import { AlertTriangle, Bell, Info, CheckCircle2 } from "lucide-react";
import AlertCard from "./AlertCard";

const AlertSection = () => {
  return (
    <div className="space-y-4 mt-4">
      <h2 className="text-lg font-medium tracking-tight">Uyarılar ve Bildirimler</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <AlertCard 
          title="Düşük Stok Uyarısı"
          description="5 kritik ürün kategorisinde stok seviyesi kritik eşiğin altına düştü."
          icon={<AlertTriangle className="h-5 w-5" />}
          variant="warning"
          action={{
            label: "Stokları Görüntüle",
            onClick: () => console.log("View stocks clicked")
          }}
        />
        
        <AlertCard 
          title="Yeni Bağış Onayı Bekliyor"
          description="12 yeni bağış talebi onay bekliyor. En eski talep 2 saat önce oluşturuldu."
          icon={<Bell className="h-5 w-5" />}
          variant="info"
          action={{
            label: "İncele",
            onClick: () => console.log("Review clicked")
          }}
        />
        
        <AlertCard 
          title="Bakım Hatırlatması"
          description="3 forklift için planlı bakım tarihi yaklaşıyor (3 gün içinde)."
          icon={<Info className="h-5 w-5" />}
          variant="default"
          action={{
            label: "Takvimi Gör",
            onClick: () => console.log("View calendar clicked")
          }}
        />
        
        <AlertCard 
          title="Sevkiyat Tamamlandı"
          description="İzmir'e yapılan 3 sevkiyat başarıyla tamamlandı ve teslim alındı."
          icon={<CheckCircle2 className="h-5 w-5" />}
          variant="success"
          action={{
            label: "Detaylar",
            onClick: () => console.log("Details clicked")
          }}
        />
      </div>
    </div>
  );
};

export default AlertSection;
